// 不加密的请求方式
import axios from 'axios';
import { baseUrl } from './baseUrl';
import router from '../router';
import { Message } from 'element-ui';
import store from '@/store';

/**
 * 判断当前是否为生产环境
 */
const isProduction = process.env.NODE_ENV === 'production';

/** baseURL */
const baseURL = baseUrl;

/** 文件上传路径 */
// export const uploadUrl = `${baseURL}/design/oss/file`

const isAbsoluteUrl = (url) => /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);

const normalizeRequestUrl = (url) => {
  if (!url || !baseURL || isAbsoluteUrl(url)) {
    return url;
  }

  if (url === baseURL) {
    return '';
  }

  if (url.indexOf(`${baseURL}/`) === 0) {
    return url.slice(baseURL.length);
  }

  return url;
};

// axios默认配置
// 超时时间
axios.defaults.timeout = 1000 * 600;
// 默认地址
axios.defaults.baseURL = baseURL;

// http request 拦截器
// app_code: 'industry',  用来区分产业大脑和阳明心学gpt
axios.interceptors.request.use(
  (config) => {
    config.url = normalizeRequestUrl(config.url);

    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    // 刷新token
    if (response.headers.refreshToken) {
      localStorage.setItem('token', response.headers.refreshToken);
    }

    // 如果响应类型是blob（文件下载），直接返回
    if (response.config.responseType === 'blob') {
      return Promise.resolve(response.data);
    }

    if (response.status === 200) {
      if (response.data.code === 200) {
        return Promise.resolve(response.data);
      } else if (response.data.code === 401) {
        // token失效,清除用户信息
        store.commit('user/updateUserInfo', null);
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
        return Promise.reject(response.data);
      } else {
        Message.error(response.data.message || response.data.msg || '操作失败');
        return Promise.reject(response.data);
      }
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (!window.navigator.onLine) {
      Message.error('网络连接失败');
    } else if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('user/updateUserInfo', null);
          Message.error('登录已过期,请重新登录');
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
          break;
        case 403:
          Message.error('没有权限访问');
          break;
        case 404:
          Message.error('请求的资源不存在');
          break;
        default:
          Message.error(error.response.data.message || '服务器错误');
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
